













































import { Component, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { mixins } from 'vue-class-component';
import BaseTable from '@/components/BaseTable.vue';
import BasePagination from '@/components/base/BasePagination.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';
import { Group } from '@/store/modules/admin/types/admin.types';
import { PaginationMixin } from '@/components/base/pagination.mixin';
import { RootState } from '@/store/store';
import UserRowPermission from '@/views/RolesAndPermissions/components/UserRowPermission.vue';
import SortableTableHeader from '@/components/SortableTableHeader.vue';
import { MyjbiGroupMember } from '@/jbi-shared/types/myjbi-group.types';

@Component({
  components: {
    BaseTable,
    BasePagination,
    BaseLoading,
    SortableTableHeader,
    UserRowPermission
  }
})
export default class UserListPermission extends mixins(PaginationMixin) {
  @Prop() public items!: Group[];
  @Prop(Number) public currentPage!: number;
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;
  @Prop({ type: Number, default: 1 }) public firstLvl!: number;
  @Prop(Boolean) public allGroupsExpanded!: boolean;
  @Prop(String) public groupLabel!: string;
  @Prop(Boolean) public expandGroupFilter!: boolean;
  @Prop(String) public sortColumn!: string;
  @Prop(String) public sortOrder!: 'ASC' | 'DESC';
  @Prop({ default: '' }) public id!: number;
  @Prop({
    type: Object,
    default: () => ({ items: [], itemCount: 0, totalItems: 0, pageCount: 0 })
  })
  public filteredUserMembers!: {
    items: MyjbiGroupMember[];
    itemCount: number;
    totalItems: number;
    pageCount: number;
  };

  public groupRowKey: number = 0;
  public showMemberCount: boolean = false;
  public filteredGroupIds: number[] = [];

  @State((state: RootState) => state.admin.apiState.getGroups.success)
  public getGroupsListSuccess!: boolean;

  get groups() {
    return this.items || [];
  }

  get firstLvlGroups() {
    return this.groups?.filter((item) => item.nlevel >= this.firstLvl);
  }

  get membersinGroup() {
    return this.filteredUserMembers?.items;
  }

  get isPaginated() {
    return typeof this.totalNumberOfPage === 'number';
  }

  getChildren(group: Group) {
    const path = group.path;
    return this.groups.filter((g) => g.path === path + '.' + g.id);
  }

  public onClickHeaderColumn(columnName: string) {
    if (this.sortColumn === columnName) {
      return this.$emit('sort', {
        sortColumn: columnName,
        sortOrder: this.sortOrder === 'ASC' ? 'DESC' : 'ASC'
      });
    }
    this.$emit('sort', {
      sortColumn: columnName,
      sortOrder: 'DESC'
    });
    this.groupRowKey += 1;
  }

  public getSortOrderOfColumn(name: string) {
    if (this.sortColumn === name) {
      return this.sortOrder;
    }
    return 'ASC';
  }
}
